import {
    openModal,
    closeModal,
} from '../../../../assets/src/js/common/modals';

import '../sass/media-gallery.scss';

(() => {
    const $mediaGalleryBlocks = document.querySelectorAll('.media-gallery');

    $mediaGalleryBlocks.forEach($mediaGalleryBlock => {
        let players = [];
        let carousel = null;
        let allowCarouselChangeEvent = true;
        let allowModalCloseEvent = true;

        const $mediaCardLinks = $mediaGalleryBlock.querySelectorAll('.media-card__inner');
        const $modal = $mediaGalleryBlock.querySelector('.media-gallery__modal');
        const $modalPlayButton = $mediaGalleryBlock.querySelector('.media-gallery__modal-play-button');
        const $modalMaximiseButton = $mediaGalleryBlock.querySelector('.media-gallery__modal-maximise-button');
        const $modalDownloadButton = $mediaGalleryBlock.querySelector('.media-gallery__modal-download-button');
        const $carousel = $mediaGalleryBlock.querySelector('.media-gallery__carousel');
        const $carouselSlides = $mediaGalleryBlock.querySelectorAll('.media-gallery__carousel-slide');
        const $carouselControlsPrev = $mediaGalleryBlock.querySelector('.media-gallery__carousel-controls-prev');
        const $carouselControlsNext = $mediaGalleryBlock.querySelector('.media-gallery__carousel-controls-next');
        const $videoCarouselSlides = $mediaGalleryBlock.querySelectorAll('.media-gallery__carousel-slide--video');
        const $modalCounterCurrent = $mediaGalleryBlock.querySelector('.media-gallery__modal-counter-current');
        const $modalBottom = $mediaGalleryBlock.querySelector('.media-gallery__modal-bottom');
        const $carouselNav = $mediaGalleryBlock.querySelector('.media-gallery__carousel-nav');
        const $carouselNavSlides = $mediaGalleryBlock.querySelectorAll('.media-gallery__carousel-nav-slide');
        const $carouselPlayers = $mediaGalleryBlock.querySelectorAll('.media-gallery__carousel-player');
        const $carouselNavButtons = $mediaGalleryBlock.querySelectorAll('.media-gallery__carousel-nav-slide-button');
        const $carouselNavToggle = $mediaGalleryBlock.querySelector('.media-gallery__carousel-nav-toggle');

        const initModal = () => {
            if (!$modal) return;

            $modal.addEventListener('modalclose', () => {
                if (document.fullscreenElement && document.exitFullscreen) {
                    document.exitFullscreen();
                }
            });
        };

        const stopPlayers = () => {
            if (!players) return;

            players.forEach(player => {
                player.stop();
            });
        };

        const initPlayers = () => {
            if (!$carouselPlayers) return;

            const initialSlideIndex = $carousel?.dataset?.initialSlideIndex ? parseInt($carousel.dataset.initialSlideIndex) : 0;

            $carouselPlayers.forEach(($player, index) => {
                const player = new Plyr($player, {
                    autoplay: $modal.classList.contains('modal--active') && index === initialSlideIndex,
                });

                players.push(player);
            });
        };

        const initCarousel = () => {
            if (!$carousel) return;

            const initialSlideIndex = $carousel?.dataset?.initialSlideIndex ? parseInt($carousel.dataset.initialSlideIndex) : 0;

            carousel = new Swiper($carousel, {
                initialSlide: initialSlideIndex,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                navigation: {
                    nextEl: $carouselControlsNext,
                    prevEl: $carouselControlsPrev,
                },
            });

            carousel.on('realIndexChange', swiper => {
                const index = !isNaN(swiper?.realIndex) ? swiper.realIndex : 0;

                if ($modalCounterCurrent) {
                    $modalCounterCurrent.innerHTML = index + 1;
                }

                const $activeCarouselNavSlide = $mediaGalleryBlock.querySelector('.media-gallery__carousel-nav-slide--active');

                if ($activeCarouselNavSlide) $activeCarouselNavSlide.classList.remove('media-gallery__carousel-nav-slide--active');

                if ($carouselNavSlides?.[index]) {
                    $carouselNavSlides[index].classList.add('media-gallery__carousel-nav-slide--active');
                }

                if (!allowCarouselChangeEvent) return;

                const { mediaId, imageUrl } = $carouselSlides?.[index]?.dataset;

                if (!mediaId) return;

                const url = new URL(window.location.href);
                const urlParams = new URLSearchParams(url.search);

                urlParams.set('media_id', mediaId);

                window.history.replaceState({
                    url: url?.origin + url?.pathname + '?' + urlParams.toString(),
                }, '', url?.origin + url?.pathname + '?' + urlParams.toString());

                if ($modalDownloadButton) {
                    $modalDownloadButton.href = imageUrl ?? '';
                }

                stopPlayers();
            });

            if ($carouselNav) {
                new Swiper($carouselNav, {
                    initialSlide: initialSlideIndex,
                    slidesPerView: 'auto',
                    spaceBetween: 5,
                    loopAdditionalSlides: 2,
                });
            }

            if ($carouselNavButtons) {
                $carouselNavButtons.forEach($carouselNavButton => {
                    $carouselNavButton.addEventListener('click', () => {
                        const { slideIndex } = $carouselNavButton.dataset;

                        carousel.slideTo(slideIndex);
                    });
                })
            }

            if ($modalPlayButton) {
                $modalPlayButton.addEventListener('click', () => {
                    if (carousel?.autoplay?.running) {
                        carousel.autoplay.stop();
                    } else {
                        carousel.autoplay.start();
                    }
                });

                carousel.on('autoplayStart', () => {
                    $modalPlayButton.classList.add('media-gallery__modal-play-button--playing');
                });
    
                carousel.on('autoplayStop', () => {
                    $modalPlayButton.classList.remove('media-gallery__modal-play-button--playing');
                });
            }

            if ($modalMaximiseButton) {
                $modalMaximiseButton.addEventListener('click', () => {
                    if (!document.fullscreenElement && $modal.requestFullscreen) {
                        $modal.requestFullscreen();
                    }

                    if (document.fullscreenElement && document.exitFullscreen) {
                        document.exitFullscreen();
                    }
                });

                $modal.addEventListener('fullscreenchange', e => {
                    if (document.fullscreenElement === $modal) {
                        $modalMaximiseButton.classList.add('media-gallery__modal-maximise-button--maximised');
                    } else {
                        $modalMaximiseButton.classList.remove('media-gallery__modal-maximise-button--maximised');
                    }
                });
            }

            if ($carouselNavToggle) {
                $carouselNavToggle.addEventListener('click', () => {
                    if ($modalBottom.classList.contains('media-gallery__modal-bottom--hidden')) {
                        $modalBottom.style.height = '0px';

                        window.requestAnimationFrame(() => {
                            $modalBottom.classList.remove('media-gallery__modal-bottom--hidden');

                            $modalBottom.style.height = `${$modalBottom.scrollHeight}px`;

                            setTimeout(() => {
                                $modalBottom.style.height = '';
                            }, 300);
                        });
                    } else {
                        $modalBottom.style.height = `${$modalBottom.scrollHeight}px`;

                        window.requestAnimationFrame(() => {
                            $modalBottom.classList.add('media-gallery__modal-bottom--hidden');

                            $modalBottom.style.height = '0';

                            setTimeout(() => {
                                $modalBottom.style.height = '';
                            }, 300);
                        });
                    }
                });
            }
        };

        const initGalleryCardLinks = () => {
            if (!$mediaCardLinks || !$modal) return;

            $mediaCardLinks.forEach($mediaCardLink => {
                $mediaCardLink.addEventListener('click', e => {
                    e.preventDefault();

                    const { slideIndex, imageUrl } = $mediaCardLink.dataset;

                    allowCarouselChangeEvent = false;

                    carousel?.slideTo(slideIndex, 0, false);
                
                    allowCarouselChangeEvent = true;

                    window.history.pushState({
                        url: $mediaCardLink?.href,
                    }, '', $mediaCardLink?.href);

                    if ($modalDownloadButton && imageUrl) {
                        $modalDownloadButton.href = imageUrl ?? '';
                    }

                    openModal($modal);
                });
            });
        };

        const initInitialState = () => {
            const url = new URL(window.location.href);
            const urlParams = new URLSearchParams(url.search);

            if (urlParams.get('media_id')) {
                window.history.replaceState({
                    url: window.location.href,
                }, '', window.location.href);
            } else {
                window.history.replaceState({
                    url: window.location.href,
                }, '', window.location.href);
            }
        };

        const initVideoCarouselSlideFormats = () => {
            if (!$videoCarouselSlides) return;

            const videoCarouselSlideResizeObserver = new ResizeObserver(entries => {
                entries.forEach(entry => {
                    setVideoCarouselSlideFormat(entry.target);
                });
            });

            setVideoCarouselSlideFormats();

            $videoCarouselSlides.forEach($videoCarouselSlide => {
                videoCarouselSlideResizeObserver.observe($videoCarouselSlide);
            });
        };

        const setVideoCarouselSlideFormat = $videoCarouselSlide => {
            const $video = $videoCarouselSlide.querySelector('.media-gallery__carousel-slide-video');

            $videoCarouselSlide.classList.remove('media-gallery__carousel-slide--video-full-height');

            if ($video.clientHeight > $videoCarouselSlide.clientHeight) {
                $videoCarouselSlide.classList.add('media-gallery__carousel-slide--video-full-height');
            }
        }

        const setVideoCarouselSlideFormats = () => {
            if (!$videoCarouselSlides) return;

            $videoCarouselSlides.forEach($videoCarouselSlide => {
                setVideoCarouselSlideFormat($videoCarouselSlide);
            });
        };

        window.addEventListener('popstate', e => {
            if (!carousel || !$modal || !e.state?.url) return;

            const url = new URL(e.state.url);
            const urlParams = new URLSearchParams(url.search);

            const mediaId = urlParams.get('media_id');

            if (mediaId) {
                const $carouselSlide = $mediaGalleryBlock.querySelector('.media-gallery__carousel-slide[data-media-id="' + mediaId + '"]');

                if (!$carouselSlide) return;
                
                const { slideIndex } = $carouselSlide?.dataset;

                if (!slideIndex) return;

                carousel?.slideTo(slideIndex, 0, false);
                carousel?.slideTo(slideIndex, 0, false);
            
                openModal($modal);
            } else {
                allowModalCloseEvent = false;
                closeModal($modal);
                allowModalCloseEvent = true;

                stopPlayers();
            }
        });

        $modal?.addEventListener('modalclose', () => {
            if (!allowModalCloseEvent) return;

            const closeUrlParams = $modal?.dataset?.closeUrlParams ? JSON.parse($modal.dataset.closeUrlParams) : null;

            stopPlayers();

            const url = new URL(window.location.href);
            const urlParams = new URLSearchParams();

            if (closeUrlParams) {
                for (const property in closeUrlParams) {
                    if (!closeUrlParams[property]) continue;

                    urlParams.set(property, closeUrlParams[property]);
                }
            }

            window.history.pushState({
                url: url?.origin + url?.pathname + '?' + urlParams.toString()
            }, '', url?.origin + url?.pathname + '?' + urlParams.toString());
        });

        initModal();
        initPlayers();
        initCarousel();
        initGalleryCardLinks();
        initInitialState();
        initVideoCarouselSlideFormats();
    });
})();
